var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcOseo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_1361",
    "data-name": "Grupo 1361",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 68.1,
    height: 68.096,
    viewBox: "0 0 68.1 68.096",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_707",
    "data-name": "Trazado 707",
    d: "M450.095,19.409c-.546.259-1.092.6-1.638.92a7.065,7.065,0,0,1-2.932,1.265c-.834.115-1.782-.6-2.731-1.236a11.809,11.809,0,0,0-1.466-.891,7.627,7.627,0,0,0-5.174-.517A13.062,13.062,0,0,0,432.76,20.5,7.708,7.708,0,0,1,428.505,22a2.552,2.552,0,0,0-2.3,1.15,2.962,2.962,0,0,0-.086,2.932,2.657,2.657,0,0,0,2.328,1.437c2.674.086,4.8-1.035,6.813-2.127.633-.345,1.265-.69,1.926-1.006a2.346,2.346,0,0,1,2.357.4c1.7,1.064,3.651,2.271,6.008,2.328a11.664,11.664,0,0,0,5.864-2.127c.862-.517,1.84-1.035,2.587-.661a11.353,11.353,0,0,1,1.667,1.035,14.3,14.3,0,0,0,1.552.977,10.6,10.6,0,0,0,5.088,1.265c.288,0,.575,0,.862-.029a2.842,2.842,0,0,0,2.616-3.162,2.448,2.448,0,0,0-2.731-2.386h.029a6.209,6.209,0,0,1-3.852-.92l-.949-.6a16.816,16.816,0,0,0-2.559-1.437,5.817,5.817,0,0,0-2.249-.426,8.194,8.194,0,0,0-3.386.771m0-9.314a17.907,17.907,0,0,0-1.61.92,6.672,6.672,0,0,1-2.961,1.265,5.69,5.69,0,0,1-2.76-1.236,11.506,11.506,0,0,0-1.437-.891,7.629,7.629,0,0,0-5.174-.518,13.062,13.062,0,0,0-3.393,1.552c-1.38.805-2.674,1.581-4.226,1.495a2.584,2.584,0,0,0-2.3,1.15,2.961,2.961,0,0,0-.087,2.932,2.658,2.658,0,0,0,2.328,1.437c2.674.115,4.773-1.035,6.785-2.127.633-.345,1.265-.69,1.926-1.006.69-.344,1.351-.23,2.357.374,1.7,1.064,3.622,2.271,6.008,2.328a11.245,11.245,0,0,0,5.864-2.127c1.208-.747,1.984-.948,2.559-.69a13.451,13.451,0,0,1,1.7,1.035,17.687,17.687,0,0,0,1.552.977,10.6,10.6,0,0,0,5.088,1.265,8.586,8.586,0,0,0,.862-.029,2.842,2.842,0,0,0,2.616-3.162,2.448,2.448,0,0,0-2.731-2.386l.029.057a5.934,5.934,0,0,1-3.852-.92c-.316-.2-.633-.4-.92-.6a13.964,13.964,0,0,0-2.588-1.437,5.808,5.808,0,0,0-2.248-.427,8.194,8.194,0,0,0-3.386.772m.057-9.343a15.362,15.362,0,0,0-1.61.92,7.09,7.09,0,0,1-2.961,1.294,5.61,5.61,0,0,1-2.731-1.237,10,10,0,0,0-1.466-.891,7.625,7.625,0,0,0-5.175-.518,13.039,13.039,0,0,0-3.392,1.552,7.7,7.7,0,0,1-4.226,1.495,2.617,2.617,0,0,0-2.3,1.15,2.962,2.962,0,0,0-.086,2.932,2.657,2.657,0,0,0,2.328,1.437h-.057a13.42,13.42,0,0,0,6.785-2.127c.633-.345,1.265-.69,1.955-1.006a2.263,2.263,0,0,1,2.357.374c1.7,1.064,3.622,2.271,6.008,2.328a11.57,11.57,0,0,0,5.865-2.127c.862-.546,1.84-1.035,2.587-.661A10.576,10.576,0,0,1,455.7,6.7a12.653,12.653,0,0,0,1.552.977,10.623,10.623,0,0,0,5.117,1.265c.288,0,.575,0,.862-.029a2.842,2.842,0,0,0,2.616-3.162A2.456,2.456,0,0,0,463.117,3.4a6.125,6.125,0,0,1-3.823-.92c-.316-.2-.6-.374-.891-.575A16.27,16.27,0,0,0,455.787.436a5.938,5.938,0,0,0-2.3-.436,8.072,8.072,0,0,0-3.339.752",
    transform: "translate(-425.773)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -3.472,
    y1: 2.127,
    x2: -3.464,
    y2: 2.127,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3bf7d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#3bf7d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394,
    stopColor: "#2deddc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#09d3f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ceff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_975",
    "data-name": "Grupo 975"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_1732",
    "data-name": "Rect\\xE1ngulo 1732",
    fill: "none",
    stroke: "#1de9b6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68.1,
    height: 68.096,
    rx: 14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 67.1,
    height: 67.096,
    rx: 13.5,
    fill: "none"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1333",
    "data-name": "Grupo 1333",
    transform: "translate(14.008 20.247)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_969",
    "data-name": "Grupo 969",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1736",
    "data-name": "Rect\\xE1ngulo 1736",
    width: 48.116,
    height: 48.116,
    transform: "translate(-13.999 13.746) rotate(-45)",
    fill: "url(#linear-gradient)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOseo);
export default __webpack_public_path__ + "static/media/ic_oseo.10df4aad9ec6d13c852329baf4e729d9.svg";
export { ForwardRef as ReactComponent };